/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_SettleInputs */

const cs_deal_payments_settle = /** @type {(inputs: Deal_Payments_SettleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit zaplaceno`)
};

const en_deal_payments_settle = /** @type {(inputs: Deal_Payments_SettleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark paid`)
};

/**
* | output |
* | --- |
* | "Mark paid" |
*
* @param {Deal_Payments_SettleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_settle = /** @type {((inputs?: Deal_Payments_SettleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_SettleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_settle(inputs)
	return cs_deal_payments_settle(inputs)
});